import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EVENTS_CONFIG } from '@app-core/constants/constants';
import { DataService } from '@app-core/services/data/data.service';
import { StatsData } from '@app-reports/models/reports.model';

@Component({
  selector: 'app-coaching-effectiveness-driver-stats',
  templateUrl: './coaching-effectiveness-driver-stats.component.html',
  styleUrls: ['./coaching-effectiveness-driver-stats.component.scss'],
})
export class CoachingEffectivenessDriverStatsComponent implements OnChanges {
  @Input() public loader: boolean;
  @Input() public statsData: StatsData;
  @Input() public currentMetricUnit: string;

  public eventsConfig = EVENTS_CONFIG;

  constructor(public dataService: DataService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentMetricUnit) {
      this.currentMetricUnit = changes.currentMetricUnit.currentValue;
    }
  }
}
